"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PAGE_SIZE = exports.DEFAULT_FIRST_PAGE = void 0;
exports.DEFAULT_FIRST_PAGE = 0;
exports.DEFAULT_PAGE_SIZE = 10;
